import { fromNullable, getOrElse } from 'effect/Option';
import { create } from 'mutative';
import { pipe } from './syncPipe';
export const valueOrDefault = (defaultInput) => (value) => pipe(value, fromNullable, getOrElse(() => defaultInput));
export const fallbackMerge = (fallback) => (value) => ({
    ...fallback,
    ...value,
});
export const overwriteMerge = (overwriteWith) => (value) => ({
    ...value,
    ...overwriteWith,
});
export const tap = (fn) => a => {
    const result = fn(a);
    if (result instanceof Promise) {
        return result.then(() => a);
    }
    return a;
};
export const mutate = (fn) => a => create(draft => {
    fn(draft);
})(a);
export const removeEmptyKeys = (obj) => Object.fromEntries(Object.entries(obj).filter(([_, v]) => v !== null && v !== undefined));
export const removeEmptyKeysAndArrays = (obj) => Object.fromEntries(Object.entries(obj).filter(([_, v]) => {
    if (Array.isArray(v)) {
        return v.length > 0;
    }
    return v !== null && v !== undefined;
}));
export const deepRemoveUndefinedAndEmpty = (data) => {
    if (data === null || data === undefined) {
        return data;
    }
    if (Array.isArray(data)) {
        return data
            .map(item => deepRemoveUndefinedAndEmpty(item))
            .filter(item => item !== undefined);
    }
    if (typeof data === 'object') {
        const cleaned = {};
        for (const [key, value] of Object.entries(data)) {
            if (value === undefined) {
                continue;
            }
            const cleanedValue = deepRemoveUndefinedAndEmpty(value);
            if (cleanedValue !== null &&
                typeof cleanedValue === 'object' &&
                cleanedValue.constructor === Object &&
                Object.keys(cleanedValue).length === 0) {
                continue;
            }
            cleaned[key] = cleanedValue;
        }
        return cleaned;
    }
    return data;
};
//# sourceMappingURL=functional-utils.js.map